export default {"src":"/_next/static/image/public/images/ic_insurance_trash.f129a5db743c36cdc4fb75577d9a9b50.svg","height":34,"width":34};